export default "__VITE_ASSET__HefYnvUl__"